import styled from 'styled-components';
import ReportSMSSummary from './components/ReportSMSSummary';
import ReportSMSFilter from './components/ReportSMSFilter';
import useGetReportSMS from '../../services/hooks/useGetReportSMS';
import useGetSummaryReportSMS from '../../services/hooks/useGetSummaryReportSMS';
import ReportSMSTable from './components/ReportSMSTable';

const ReportSMSPage = () => {
  const { data, params, setParams } = useGetReportSMS();
  const { data: summaryData, setParams: setSummaryParams } = useGetSummaryReportSMS();
  return (
    <Container>
      <ReportSMSSummary data={summaryData} />
      <ReportSMSFilter params={params} setParams={setParams} setSummaryParams={setSummaryParams} />
      <ReportSMSTable data={data} params={params} setParams={setParams}/>
    </Container>
  );
};

export default ReportSMSPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 1.5rem;
`;
